module.exports = __webpack_public_path__ + "img/hunt-refining-logo.cb91b97d.jpg";